/* eslint-disable */

import { type SVGProps } from "react";
import { cn } from "../../lib/utils";

export function Sheets({
  className,
  ...props
}: SVGProps<SVGSVGElement>) {
  return (
    <svg
      className={cn("w-[1em] h-[1em]", className)}
      viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      
<path d="M9.13327 0.56134H3.38527C2.82661 0.56134 2.37061 1.01801 2.37061 1.57601V14.424C2.37061 14.982 2.82727 15.4387 3.38527 15.4387H12.1759C12.7339 15.4387 13.1906 14.982 13.1906 14.424V4.61867L10.8239 2.92801L9.13327 0.56134Z" fill="#0F9D58"></path>
<path d="M5.07544 7.83069V12.7334H10.4854V7.83069H5.07544ZM7.44211 12.0574H5.75277V11.212H7.44344L7.44211 12.0574ZM7.44211 10.7047H5.75277V9.86002H7.44344L7.44211 10.7047ZM7.44211 9.35269H5.75277V8.50669H7.44344L7.44211 9.35269ZM9.80877 12.0574H8.11944V11.212H9.81011L9.80877 12.0574ZM9.80877 10.7047H8.11944V9.86002H9.81011L9.80877 10.7047ZM9.80877 9.35269H8.11944V8.50669H9.81011L9.80877 9.35269Z" fill="#F1F1F1"></path>
<path d="M9.42993 4.32202L13.1899 8.08202V4.61869L9.42993 4.32202Z" fill="url(#paint0_linear_879_129)"></path>
<path d="M9.1333 0.56134V3.60467C9.1333 4.16467 9.58663 4.61867 10.1473 4.61867H13.1906L9.1333 0.56134Z" fill="#87CEAC"></path>
<path d="M3.38527 0.56134C2.82661 0.56134 2.37061 1.01801 2.37061 1.57601V1.66001C2.37061 1.10267 2.82727 0.646007 3.38527 0.646007H9.13327V0.56134H3.38527Z" fill="white" fill-opacity="0.2"></path>
<path d="M12.3293 15.354H3.53793C3.26927 15.3531 3.01186 15.246 2.82189 15.0561C2.63192 14.8661 2.5248 14.6087 2.52393 14.34V14.424C2.52393 14.982 2.97993 15.4387 3.53793 15.4387H12.3293C12.8873 15.4387 13.3433 14.982 13.3433 14.424V14.3394C13.3433 14.8974 12.8873 15.354 12.3293 15.354Z" fill="#263238" fill-opacity="0.2"></path>
<path d="M10.1473 4.61868C10.0141 4.61876 9.88222 4.59259 9.75916 4.54167C9.63609 4.49074 9.52428 4.41605 9.4301 4.32188C9.33592 4.2277 9.26124 4.11588 9.21031 3.99282C9.15938 3.86976 9.13321 3.73786 9.1333 3.60468V3.68934C9.1333 4.24934 9.58663 4.70334 10.1473 4.70334H13.1906V4.61868H10.1473Z" fill="#263238" fill-opacity="0.1"></path>
<path d="M9.13327 0.56134H3.38527C2.82661 0.56134 2.37061 1.01801 2.37061 1.57601V14.424C2.37061 14.982 2.82727 15.4387 3.38527 15.4387H12.1759C12.7339 15.4387 13.1906 14.982 13.1906 14.424V4.61867L9.13327 0.56134Z" fill="url(#paint1_radial_879_129)"></path>
<defs>
<linearGradient id="paint0_linear_879_129" x1="11.3099" y1="4.64469" x2="11.3099" y2="8.08269" gradientUnits="userSpaceOnUse">
<stop stopColor="#263238" stopOpacity="0.2"></stop>
<stop offset="1" stopColor="#263238" stopOpacity="0.02"></stop>
</linearGradient>
<radialGradient id="paint1_radial_879_129" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(2.71327 0.85734) scale(17.4467 17.4467)">
<stop stopColor="white" stopOpacity="0.1"></stop>
<stop offset="1" stopColor="white" stopOpacity="0"></stop>
</radialGradient>
</defs>

    </svg>
  );
}
